import React from 'react';
import ImageEditor from '../../../../components/imageeditor/ImageEditor';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

const DeviceImage = ({
  values,
  form,
  field,
  scaleImage = false,
  width = 300,
  height = 300,
  maxWidth,
  maxHeight,
}) => {
  const handleImageLoaded = file => {
    form.setFieldValue(`${field.name}.file`, file);
  };

  const handleDataUrlUpdate = (dataURL, scale, position) => {
    form.setFieldValue(`${field.name}.image`, dataURL);
    form.setFieldValue(`${field.name}.scale`, scale);
    form.setFieldValue(`${field.name}.position`, position);
  };
  const handleImageClear = () => {
    form.setFieldValue(field.name, {url: ''});
  };
  const getImageFields = () => {
    const file = _get(values, `${field.name}.file`);
    const scale = _get(values, `${field.name}.scale`);
    const position = _get(values, `${field.name}.position`);
    const url = _get(values, `${field.name}.url`, '');
    return (
      <ImageEditor
        imageUrl={url}
        enableScale={scaleImage}
        onDataUrlUpdate={handleDataUrlUpdate}
        onImageClear={handleImageClear}
        imageWidth={width}
        imageHeight={height}
        displayWidth={maxWidth}
        displayHeight={maxHeight}
        defaultPosition={position}
        defaultScale={scale}
        imageFile={file}
        onImageLoaded={handleImageLoaded}
      />
    );
  };

  return <>{getImageFields()}</>;
};

DeviceImage.propTypes = {
  imageUrl: PropTypes.string,
  scaleImage: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  clearFormFields: PropTypes.array,
};

export default DeviceImage;
